import { ArticleMenu, CurrentJobOption, DefaultOpeningOption, DefaultProfileOption, FavoriteMenu, HomeMenu, LogoutMenu, MailMenu, RegistrationMenu, SearchMenu, WorkExperienceOption } from "@/User/Constants/menu";
import { TYPE_COMPANY, TYPE_INDIVIDUAL } from "@/User/Constants/user";
import { isEmpty, isNull } from "lodash";

const getCompanySections = ({ user }) => [
    {
        isEmpty: isNull(user?.company_name),
    },
    {
        isEmpty: isNull(user?.department_name),
    },
    {
        isEmpty: isNull(user?.industry_code),
    },
    {
        isEmpty: isNull(user?.zipcode) || isNull(user?.prefecture_id) || isNull(user?.city) || isNull(user?.address),
    },
    {
        isEmpty: isNull(user?.lastname) || isNull(user?.firstname) || isNull(user?.lastname_kana) || isNull(user?.firstname_kana),
    },
    {
        isEmpty: isNull(user?.tel),
    },
    {
        isEmpty: isEmpty(user?.url),
    }
];

const getPersonalSection = ({ user }) => [
    {
        isEmpty: isNull(user?.birthday),
    },
    {
        isEmpty: isNull(user?.yearly_income),
    },
    {
        isEmpty: isNull(user?.sex),
    },
    {
        isEmpty: isNull(user?.zipcode) || isNull(user?.prefecture_id) || isNull(user?.city) || isNull(user?.address),
    },
    {
        isEmpty: isNull(user?.lastname) || isNull(user?.firstname) || isNull(user?.lastname_kana) || isNull(user?.firstname_kana),
    },
    {
        isEmpty: isNull(user?.tel),
    },
];


const getPreferenceSections = ({ user }) => [
    {
        isEmpty: isNull(user?.opening_fund),
    },
    {
        isEmpty: isNull(user?.opening_time),
    },
    {
        isEmpty: isNull(user?.opening_area),
    },
    {
        isEmpty: isEmpty(user?.industries),
    }
];


export const getMenuData = ({ user }) => {
    const profileSection = user?.type == TYPE_COMPANY
        ? getCompanySections({ user })
        : getPersonalSection({ user });

    const preferenceSection = getPreferenceSections({ user });

    const emptyFieldsProfile = profileSection.reduce((count, item) => count + (item.isEmpty ? 1 : 0), 0);
    const emptyFieldsPreference = preferenceSection.reduce((count, item) => count + (item.isEmpty ? 1 : 0), 0);

    DefaultProfileOption.notify = !emptyFieldsProfile ? null : emptyFieldsProfile + '/' + profileSection.length + "項目未入力";
    DefaultOpeningOption.notify = !emptyFieldsPreference ? null : emptyFieldsPreference + '/' + preferenceSection.length + "項目未入力";

    let registrationOptions = [
        DefaultProfileOption,
        DefaultOpeningOption,
    ];

    if (user?.type === TYPE_INDIVIDUAL) {
        registrationOptions = [
            ...registrationOptions,
            CurrentJobOption,
            WorkExperienceOption,
        ];
    }

    return {
        Favorite: FavoriteMenu,
        Home: HomeMenu,
        Mail: MailMenu,
        Registration: {
            ...RegistrationMenu,
            options: [
                ...registrationOptions,
            ]
        },
        Search: SearchMenu,
        Article: ArticleMenu,
        Logout: LogoutMenu,
    };
};

